import { connect } from "react-redux";
import FamilyProductView from "../components/FamilyProductView";
import { getAvailableFamilyProductForConfigurator } from "../selectors";
import {
  getAggregatedFamilyProducts,
  getDefaultFamilyProducts,
} from "../actions";

export default connect(
  (state) => ({
    familyProducts: state.familyProduct.familyProducts,
    localConfigurator: state.configurator.localConfigurator,
    familyProductsFilters: getAvailableFamilyProductForConfigurator(state),
    aggregatedFamilyProducts: state.familyProduct.aggregatedFamilyProducts,
    user: state.user.informations,
  }),
  (dispatch) => ({
    getAggregatedFamilyProducts: (values) => {
      dispatch(getAggregatedFamilyProducts(values));
    },
    getDefaultFamilyProducts: (values) => {
      dispatch(getDefaultFamilyProducts(values));
    },
  })
)(FamilyProductView);
